import { AccordionProps, AccordionSummary, Typography } from "@mui/material";
import { ChevronDownIcon } from "src/foundations/icons";
import { StyledAccordion, StyledAccordionDetails, StyledSummaryBox } from "src/components/senec-accordion/SenecAccordion.styled";

export type SenecAccordionProps = {
    /**
     * title - header title
     */
    title: string;

    /**
     * isExpanded - accordion summary is expanded
     */
    isExpanded: boolean;

    /**
     * HeaderComponent - component which will be shown right aligned in the header
     */
    HeaderComponent?: React.ReactNode;

    /**
     * onClick - click handler to expand and collapse
     */
    onClick: () => void;
} & AccordionProps;

export const SenecAccordion = ({ children, title, isExpanded, onClick, HeaderComponent, ...rest }: SenecAccordionProps) => {
    return (
        <StyledAccordion expanded={isExpanded} {...rest} disableGutters>
            <AccordionSummary id="panel-header" aria-controls="panel-content" expandIcon={<ChevronDownIcon />} onClick={onClick}>
                <StyledSummaryBox>
                    <Typography variant="h5">{title}</Typography>
                    {HeaderComponent}
                </StyledSummaryBox>
            </AccordionSummary>
            <StyledAccordionDetails>{children}</StyledAccordionDetails>
        </StyledAccordion>
    );
};
